module.exports = __webpack_public_path__ + "img/Madera-Caucho2.2940be67.jpg";